export const ORGANIC = 'organic';
export const PPC = 'ppc';
export const EMAIL = 'email';
export const NETWORK = 'network';
export const PAID_SOCIAL = 'paid social';
export const CC_3PI = '3PI';
export const SMS = 'sms';



// WEBPACK FOOTER //
// ./src/constants/sources.js